import React, { useEffect, useState, useContext } from 'react';
import { API } from '../../../API/API';
import { Color, constData } from '../../../const/Const';
import { UserContext } from '../../../context/UserContext';
import { useParams } from 'react-router-dom';
import PageHeader from '../../../components/PageHeader/PageHeader';
import ColWarn from '../../../components/ColWarn/ColWarn';
import ButtonIcon from '../../../components/ButtonIcon/ButtonIcon';
import EmpEmplHistNewOT from './New/EmpEmplHistNewOT';
import EmpEmplHistNewHR from './New/EmpEmplHistNewHR';
import EmpEmplHistNewSH from './New/EmpEmplHistNewSH';
import EmpEmplHistNewTR from './New/EmpEmplHistNewTR';
import ButtonIconOption from '../../../components/ButtonIconOption/ButtonIconOption';
import GridDefaultShimmer from '../../../components/GridDefaultShimmer/GridDefaultShimmer';
import Warning from '../../../components/Warning/Warning';

const EmpEmplHist = (props) => {

    const params = useParams();
    const { userInfo } = useContext(UserContext);

    const [dUser, setDUser] = useState({});
    const [counter, setCounter] = useState(1);
    const [data, setData] = useState([]);
    const [oData, setOData] = useState([]);

    const [showNewOT, setShowNewOT] = useState(false);
    const [showNewHR, setShowNewHR] = useState(false);
    const [showNewSH, setShowNewSH] = useState(false);
    const [showNewTR, setShowNewTR] = useState(false);
    const [historyid, setHistoryId] = useState(-1);
    const [shifttype, setShiftType] = useState();
    const [terminatetype, setTerminateType] = useState();
    const [loading, setLoading] = useState(false);

    const [columns] = useState([
        {
            name: 'Ажлын байр',
            fieldName: 'jobname',
            onRender: (item) => {
                if (item?.companyid?.toUpperCase() != userInfo?.companyid?.toUpperCase()) {
                    return (
                        <div>{item.jobname}</div>
                    );
                } else {
                    return <div style={{ color: Color.blue, cursor: 'pointer' }} onClick={() => onEdit(item.historyid, item.employmenttype)}>{item.jobname}</div>;
                }
            },
        },
        {
            name: 'Ажил эрхлэлтийн төрөл',
            fieldName: 'employmenttypename',
            onRender: (item) => {
                let vAddText = "";

                if (item?.employmenttype == 'SH' && item?.shifttype) {
                    vAddText = constData.Gov_shift_Type?.find(r => r.key == item?.shifttype)?.text;
                }

                if (item?.employmenttype == 'TR' && item?.terminatetype) {
                    vAddText = constData.Gov_Terminate_Type?.find(r => r.key == item?.terminatetype)?.text;
                }

                return (
                    <div>{item?.employmenttypename} {vAddText ? ("(" + vAddText + ")") : null}</div>
                );
            }
        },
        {
            name: 'Хуулийн этгээд',
            fieldName: 'legalentityname',
        },
        {
            name: 'Дотоод нэгж',
            fieldName: 'departmentname'
        },
        {
            name: 'Эхэлсэн',
            fieldName: 'begindate',
            onRender: (item) => {
                return (
                    <ColWarn message="Хугацаа давхардсан байна." show={item.warningbegindate} value={item.begindate} />
                );
            }
        }, {
            name: 'Дууссан',
            fieldName: 'enddate',
            onRender: (item) => {
                return (
                    <ColWarn message="Хугацаа давхардсан байна." show={item.warningenddate} value={item.enddate ? item.enddate : "Одоог хүртэл"} />
                );
            }
        }, {
            name: 'Ажилласан жил',
            fieldName: 'workedmonth'
        }, {
            name: 'Даатгуулагчийн төрөл',
            fieldName: 'insuretypename'
        }
    ]);

    const getData = async () => {
        let tData = [];
        let tDUser = {};

        try {
            setLoading(true);
            if (params?.empid > 0) {
                await API.get('/api/humanresource/employee/get?EmployeeID=' + params?.empid).then(response => {
                    if (response.status === 200 && response.data.rettype === 0) {
                        if (response.data?.retdata?.length > 0 && response.data?.retdata[0]) {
                            tDUser = response.data?.retdata[0];
                        }
                    }
                });

                await API.get('/api/humanresource/employment/get_empemplhist_list?empid=' + params?.empid).then(response => {
                    if (response.status === 200 && response.data.rettype === 0) {
                        if (response.data?.retdata?.length > 0) {
                            tData = response.data.retdata;
                        }
                    }
                });
            }
        } finally {
            setLoading(false);
        }


        setDUser(tDUser);
        setData(tData);
        setOData(tData);
    }

    useEffect(() => {
        getData();
    }, [params?.empid]);

    const onPressNewOTEmpEmplHist = () => {
        if (params?.empid > 0) {
            setHistoryId(-1);
            setShowNewOT(true);
            setCounter(r => r + 1);
        }
    }

    const onPressNewHREmpEmplHist = () => {
        if (params?.empid > 0) {
            setHistoryId(-1);
            setShowNewHR(true);
            setCounter(r => r + 1);
        }
    }

    const onPressNewSHEmpEmplHist = (p_opt, p_value) => {
        if (params?.empid > 0) {
            setShiftType(p_value.key);
            setHistoryId(-1);
            setShowNewSH(true);
            setCounter(r => r + 1);
        }
    }

    const onPressNewTREmpEmplHist = (p_opt, p_value) => {
        if (params?.empid > 0) {
            setTerminateType(p_value.key);
            setHistoryId(-1);
            setShowNewTR(true);
            setCounter(r => r + 1);
        }
    }

    const afterSave = () => {
        setShowNewOT(false);
        setShowNewHR(false);
        setShowNewSH(false);
        setShowNewTR(false);
        setHistoryId(-1);
        setCounter(r => r + 1);
        getData();
    }

    const onEdit = (p_id, p_type) => {
        setHistoryId(p_id);
        if (p_type == 'OT') {
            setShowNewOT(true);
        } if (p_type == 'HR') {
            setShowNewHR(true);
        } if (p_type == 'SH') {
            setShiftType();
            setShowNewSH(true);
        } if (p_type == 'TR') {
            setTerminateType();
            setShowNewTR(true);
        }
    }

    const onSearch = (p_data) => {
        setData(p_data);
    }

    return (
        <div>
            <div style={{ margin: "4px 16px 0px 16px" }}>
                <Warning value="Энд ажилтны танай байгууллагад болон өөр байгууллагад ажилласан түүхийг бөглөх бөгөөд зөв бөглөснөөр ээлжийн амралт, тэтгэмж бодох үед ажилласан жилээ зөв тооцоолох боломжтой болно." />
            </div>
            <PageHeader
                title={`Ажил эрхлэлтийн түүх (${data.length})`}
                buttonTitle="Өөр байгууллагад ажилласан түүх"
                onButtonClick={onPressNewOTEmpEmplHist}
                borderButton
                columns={columns}
                data={oData}
                filteredData={data}
                onSearch={onSearch}
                addButtonSpace={8}
                addButton={(
                    <div style={{ display: 'flex' }}>
                        <div>
                            <ButtonIcon text="Ажилд авсан түүх" iconName='Add' onClick={onPressNewHREmpEmplHist} />
                        </div>
                        <div style={{ marginLeft: 8 }}>
                            <ButtonIconOption text="Дотоод хөдөлгөөний түүх" iconName='Add' menuProps={{
                                items: constData.Gov_shift_Type,
                                onItemClick: onPressNewSHEmpEmplHist
                            }} />
                        </div>
                        <div style={{ marginLeft: 8 }}>
                            <ButtonIconOption text="Ажлаас чөлөөлсөн түүх" iconName='Add' menuProps={{
                                items: constData.Gov_Terminate_Type,
                                onItemClick: onPressNewTREmpEmplHist
                            }} />
                        </div>
                    </div>
                )}
                loading={loading}
            />
            <div>
                <GridDefaultShimmer
                    columns={columns}
                    data={data}
                    loading={loading} />
            </div>
            <div key={counter}>
                <EmpEmplHistNewOT historyid={historyid} afterSave={afterSave} onOpen={showNewOT} onDismiss={() => { setShowNewOT(false); setHistoryId(-1); }} empid={params?.empid} emptype={dUser.emptype} insuretypeid={dUser.insuretypeid} />
                <EmpEmplHistNewHR historyid={historyid} afterSave={afterSave} onOpen={showNewHR} onDismiss={() => { setShowNewHR(false); setHistoryId(-1); }} empid={params?.empid} emptype={dUser.emptype} insuretypeid={dUser.insuretypeid} />
                <EmpEmplHistNewSH historyid={historyid} afterSave={afterSave} onOpen={showNewSH} onDismiss={() => { setShowNewSH(false); setHistoryId(-1); }} empid={params?.empid} emptype={dUser.emptype} insuretypeid={dUser.insuretypeid} shifttype={shifttype} />
                <EmpEmplHistNewTR historyid={historyid} afterSave={afterSave} onOpen={showNewTR} onDismiss={() => { setShowNewTR(false); setHistoryId(-1); }} empid={params?.empid} emptype={dUser.emptype} insuretypeid={dUser.insuretypeid} terminatetype={terminatetype} />
            </div>
        </div>
    );
}

export default EmpEmplHist;